import { translateString } from '@src/util/intl/translateString';

export const REDUCER_INDEX = 'users';
export const BASE_URL = 'users';

export const PATHS = {
  BASE_URL,
  ACCEPT_INVITATION: `${BASE_URL}/invitation/:token`,
  ACCEPT_INVITATION_V2: `${BASE_URL}/invitationV2/:organizationId/:userId`,
  USER_PERMISSIONS: `${BASE_URL}/permissions/:userId`,
  USERS_INVITE: `${BASE_URL}/invite`,
  CREATE_USER: `${BASE_URL}/create`,
  EDIT_USER: `${BASE_URL}/edit/:userId`,
  USER_NOTIFICATIONS: `${BASE_URL}/notifications/:userId`,
  USER_INFO: `${BASE_URL}/info/:userId`,
  IMPORT_USERS: `${BASE_URL}/import`,
};

export const getRouteToUsersHome = () => PATHS.BASE_URL;

export const getRouteToUsersInvite = () => PATHS.USERS_INVITE;

export const getRouteCreateUser = () => PATHS.CREATE_USER;

export const getRouteImportUsers = () => PATHS.IMPORT_USERS;

export const getRouteEditUser = userId => PATHS.EDIT_USER.replace(':userId', userId);

export const getRouteToUserInfo = userId => PATHS.USER_INFO.replace(':userId', userId);

export const getRouteToUserPermissions = userId =>
  PATHS.USER_PERMISSIONS.replace(':userId', userId);

export const getRouteToUserNotifications = userId =>
  PATHS.USER_NOTIFICATIONS.replace(':userId', userId);

export const ALL_PERMISSIONS = ['r', 'u', 'o', 'a', 'na'];
export const PERMISSIONS_BY_DEFAULT = [];
export const USER_STATE_BY_DEFAULT = 'enabled';
export const USERS_LIST_PAGE_SIZE = 10;
export const USERS_LIST_SORT_STORAGE_KEY = 'usersListTableSort';

export const INIT_FILTERS = {
  name: {
    value: '',
    label: translateString('users.list.column.user'),
    valueType: 'string',
    clearValue: '',
    hideWhenCleared: true,
  },
  email: {
    value: '',
    label: translateString('users.list.column.email'),
    valueType: 'string',
    clearValue: '',
    hideWhenCleared: true,
  },
  state: {
    value: USER_STATE_BY_DEFAULT,
    label: translateString('users.list.column.status'),
    valueTranslated: translateString('general.active'),
    valueType: 'string',
    clearValue: 'all',
    hideWhenCleared: true,
  },
};
